import * as Sentry from '@sentry/browser';

import React from 'react';
import ReactDOM from 'react-dom';

import Root from 'scenes/Root';
import BaseStyles from 'styles/foundation';

import * as serviceWorker from './serviceWorker';

Sentry.init({
  dsn: 'https://4103b28b9bbc451aab6016a5fb65b080@sentry.io/1674654',
  beforeSend(event, hint) {
    const processedEvent = { ...event };
    const { message } = hint.originalException;

    if (message) {
      processedEvent.message = message.message;
    }

    return processedEvent;
  }
});

const render = () => {
  ReactDOM.render(
    <>
      <BaseStyles />
      <Root />
    </>,
    document.getElementById('root')
  );
};

render();
serviceWorker.unregister();
